import { useRouteMatch } from 'react-router';

import ConversationPage from '../conversation';

const ConversationBillingDetailsPage = () => {
  const { params } = useRouteMatch<{
    agent_id: string;
    conversation_id: string;
  }>();

  return (
    <ConversationPage
      agentId={params.agent_id ?? ''}
      conversationId={params.conversation_id ?? ''}
    />
  );
};

export default ConversationBillingDetailsPage;
